import { createContext } from 'react';

import { HistogramChartToolbarConfig } from '../types/histogram-props.js';

export const HistogramToolbarContext = createContext<
  Partial<HistogramChartToolbarConfig> | undefined
>(undefined);
